export const UtilSvgAtlasBuilder = wcardinal.ui.UtilSvgAtlasBuilder;